export default {
    props: {
        keyProvider: {
            type: Function,
            required: false,
            default: (item, key, idx) => key,
        },
    },
};
